import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";

export const clockRoutes: RouteRender[] = [
  lazyView(routes.clocks, () => import("./clocks").then((m) => ({ default: m.ClocksPage })), "Clocks"),
];
